/* OptiShade — productpagina: kaarten voor ruitenset/tint en de fotogalerij. */
(function () {
  'use strict';

  /* Kaarten voor ruitenset en tint. Ze sturen de variantkiezer van Horizon
     aan (die verborgen op de pagina blijft), zodat prijs, voorraad en de
     winkelwagen via het thema zelf lopen. */
  if (!customElements.get('os-varianten')) {
    class OsVarianten extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this._klaar = true;
        var self = this;
        this.addEventListener('change', function (e) {
          var t = e.target;
          if (!t.classList || !t.classList.contains('os-card__input')) return;
          self.kies(t.dataset.option, t.value);
          self.schets();
        });
        // Als de kiezer van het thema verandert (bv. na een herlaadbeurt), volgen we mee.
        this._naKiezer = function (e) {
          if (e.target && e.target.closest && e.target.closest('variant-picker')) {
            setTimeout(function () { self.volgKiezer(); }, 0);
          }
        };
        document.addEventListener('change', this._naKiezer);
        this.volgKiezer();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this._naKiezer);
        this._klaar = false;
      }

      kiezer() {
        return document.querySelector('variant-picker[data-product-id="' + this.dataset.productId + '"]');
      }

      kies(optie, waarde) {
        var k = this.kiezer();
        if (!k) return;
        var radios = k.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          var r = radios[i];
          if (r.dataset.optionName === optie && r.value === waarde) {
            if (!r.checked) r.click();
            return;
          }
        }
        // Kiezer in keuzelijst-stijl
        var selects = k.querySelectorAll('select');
        for (var j = 0; j < selects.length; j++) {
          if (selects[j].name === 'options[' + optie + ']' && selects[j].value !== waarde) {
            selects[j].value = waarde;
            selects[j].dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      volgKiezer() {
        var k = this.kiezer();
        if (k) {
          var mijn = this.querySelectorAll('.os-card__input');
          var gekozen = k.querySelectorAll('input[type="radio"]:checked');
          for (var i = 0; i < gekozen.length; i++) {
            for (var j = 0; j < mijn.length; j++) {
              if (mijn[j].dataset.option === gekozen[i].dataset.optionName && mijn[j].value === gekozen[i].value) {
                mijn[j].checked = true;
              }
            }
          }
        }
        this.schets();
      }

      schets() {
        var set = this.querySelector('.os-card__input[data-option="' + this.dataset.setOption + '"]:checked');
        var ruiten = set ? (set.dataset.ruiten || '').split(',').map(function (s) { return s.trim(); }) : [];
        var delen = this.querySelectorAll('[data-ruit]');
        for (var i = 0; i < delen.length; i++) {
          delen[i].classList.toggle('is-on', ruiten.indexOf(delen[i].dataset.ruit) !== -1);
        }
        var tekst = this.querySelector('[data-preview-text]');
        if (tekst) tekst.textContent = set ? set.value : '—';
      }
    }
    customElements.define('os-varianten', OsVarianten);
  }

  /* Fotogalerij: horizontaal scrollen met knoppen en teller. */
  if (!customElements.get('os-carousel')) {
    class OsCarousel extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this._klaar = true;
        var self = this;
        this.track = this.querySelector('[data-track]');
        this.teller = this.querySelector('[data-counter]');
        this.items = this.track ? this.track.children : [];
        var vorige = this.querySelector('[data-prev]');
        var volgende = this.querySelector('[data-next]');
        if (vorige) vorige.addEventListener('click', function () { self.ga(-1); });
        if (volgende) volgende.addEventListener('click', function () { self.ga(1); });
        if (this.track) this.track.addEventListener('scroll', function () {
          window.requestAnimationFrame(function () { self.tel(); });
        }, { passive: true });
        this.tel();
      }

      huidig() {
        if (!this.items.length) return 0;
        var links = this.track.scrollLeft, best = 0, afstand = Infinity;
        for (var i = 0; i < this.items.length; i++) {
          var d = Math.abs(this.items[i].offsetLeft - this.track.offsetLeft - links);
          if (d < afstand) { afstand = d; best = i; }
        }
        return best;
      }

      ga(stap) {
        if (!this.items.length) return;
        var doel = Math.max(0, Math.min(this.items.length - 1, this.huidig() + stap));
        this.track.scrollTo({ left: this.items[doel].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }

      tel() {
        if (this.teller && this.items.length) {
          this.teller.textContent = (this.huidig() + 1) + ' / ' + this.items.length;
        }
      }
    }
    customElements.define('os-carousel', OsCarousel);
  }
})();
